// src/components/Products/PartRequirementsSection.js
import React from 'react';
import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';

const PartRequirementsSection = ({
                                     title,
                                     fields,
                                     append,
                                     remove,
                                     register,
                                     errors,
                                     partTypes,
                                     baseName,
                                     borderTop = true
                                 }) => {
    return (
        <div className={`space-y-4 ${borderTop ? 'border-t border-gray-200 pt-6' : ''}`}>
            <div className="flex justify-between items-center">
                <h2 className="text-lg font-medium text-gray-900">{title}</h2>
                <button
                    type="button"
                    onClick={() => append({ part_type_id: '', quantity_required: 1 })}
                    className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                >
                    <PlusIcon className="h-4 w-4 mr-1" /> Add Part
                </button>
            </div>

            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                    <tr>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Part Type
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Quantity Required
                        </th>
                        <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Action
                        </th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                    {fields.map((field, index) => (
                        <tr key={field.id}>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <select
                                    {...register(`${baseName}.${index}.part_type_id`, {
                                        required: 'Part type is required'
                                    })}
                                    className={`shadow-sm p-3 focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md ${
                                        errors?.[baseName]?.[index]?.part_type_id ? 'border-red-300' : ''
                                    }`}
                                >
                                    <option value="">Select Part Type</option>
                                    {partTypes.map(partType => (
                                        <option key={partType.id} value={partType.id}>
                                            {partType.name} {partType.is_sku_specific ? '(SKU-specific)' : ''}
                                        </option>
                                    ))}
                                </select>
                                {errors?.[baseName]?.[index]?.part_type_id && (
                                    <p className="mt-1 text-sm text-red-600">
                                        {errors[baseName][index].part_type_id.message}
                                    </p>
                                )}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <input
                                    type="number"
                                    {...register(`${baseName}.${index}.quantity_required`, {
                                        required: 'Quantity is required',
                                        min: { value: 1, message: 'Quantity must be at least 1' },
                                        valueAsNumber: true
                                    })}
                                    className={`shadow-sm p-3 focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md ${
                                        errors?.[baseName]?.[index]?.quantity_required ? 'border-red-300' : ''
                                    }`}
                                    placeholder="1"
                                />
                                {errors?.[baseName]?.[index]?.quantity_required && (
                                    <p className="mt-1 text-sm text-red-600">
                                        {errors[baseName][index].quantity_required.message}
                                    </p>
                                )}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right">
                                <button
                                    type="button"
                                    onClick={() => remove(index)}
                                    className="text-red-600 hover:text-red-900"
                                >
                                    <TrashIcon className="h-5 w-5" />
                                </button>
                            </td>
                        </tr>
                    ))}
                    {fields.length === 0 && (
                        <tr>
                            <td colSpan="3" className="px-6 py-4 text-center text-sm text-gray-500">
                                No part requirements added. Click "Add Part" to add one.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PartRequirementsSection;
